import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../../utils/util';
@Pipe({
    name: 'camelCase',
    standalone: true
})
export class CamelCasePipe extends TitleCasePipe implements PipeTransform {
  private readonly SPACES_REGEX: RegExp = /\s/g;
  private readonly ALPHA_NUMERIC_REGEX: RegExp = /\W/g;
  transform(value) {
    if (!isNullOrUndefined(value)) {
      if (this.ALPHA_NUMERIC_REGEX.test(value) || this.SPACES_REGEX.test(value)) {
        // Title Case
        value = super.transform(value);
        // Remove spaces
        value = value.replace(this.SPACES_REGEX, '').trim();
        // Remove non-alphanumeric characters
        value = value.replace(this.ALPHA_NUMERIC_REGEX, '').trim();
      }
      // Make first character lower case
      return value.charAt(0).toLowerCase() + value.slice(1);
    }
    return value;
  }
}
